import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import { saveFile, useIndexedDBDispatch, useIndexedDBState } from '../../context/indexedDBContext';
import { QS_CONSTANT, DOC_FORMAT_CONFIG_VALUES } from '../../define/global';
import axios from 'axios';
import { useDispatch } from 'react-redux';
import { showToast } from '../../store/modules/toast';
import { hideFileMenu } from '../../store/modules/popup';

import newCrossImg from '../../img/ico_new_cross.png';
import newCrossImg2x from '../../img/ico_new_cross@2x.png';
import { CustomScrollbar } from '../common/CssCommon';
import ga from '../../utils/gaConnect';
import {
  getTemplates,
  useOpenNewTabWithQueryinSameDomain,
  useOpenCurrentTab
} from '../../utils/util';
import { useGenConfirmPromise } from '../confirm/Confirm';

const ContentsTitle = styled.div`
  font-size: 18px;
  color: #46494c;
  margin-left: 40px;
  height: 18px;
`;

const Container = styled.div`
  margin-top: 24px;
  height: 100%;
  width: 456px;
  display: flex;
  flex-direction: column;
`;

const Grid = styled.div`
  padding-left: calc(41px - 17px);
  padding-right: calc(40px - 23px);
  flex: 1;
  margin-bottom: 2rem;
  overflow-y: auto;
  overflow-x: hidden;
  margin-top: 27px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 8px 18px;
  width: 100%;
  //box-sizing: border-box;
  ${CustomScrollbar};
`;

const GridItem = styled.div`
  padding: 11px 0px 8px;
  box-sizing: border-box;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  &:hover {
    cursor: pointer;
    background-color: #f7f7f7;
  }

  &:active {
    background-color: #f0f0f0;
  }
`;

const GridThumnail = styled.img`
  //border: solid 1px #c8c7c7;
`;

const GridItemTitle = styled.div`
  margin-top: 11px;
  text-align: center;
  color: #282828;
  font-size: 13px;
`;

const GridThumnailBorder = styled.div`
  width: 106px;
  height: 153px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: solid 1px #c8c7c7;
  width: ${(props) => props.width};
  height: ${(props) => props.height};
`;

function NewDocumentsContents() {
  const { t, i18n } = useTranslation();
  const indexedDBState = useIndexedDBState();
  const indexedDBDispatch = useIndexedDBDispatch();
  const openCurrentTab = useOpenCurrentTab();
  const openNewTabWithQueryinSameDomain = useOpenNewTabWithQueryinSameDomain();
  const confirmPromise = useGenConfirmPromise();
  const dispatch = useDispatch();
  const templates = getTemplates(DOC_FORMAT_CONFIG_VALUES.sdk.documnetType);

  const openTemplateFile = async (fileName) => {
    try {
      const res = await axios.get(process.env.PUBLIC_URL + templates.templatePath + fileName, {
        responseType: 'arraybuffer'
      });

      const file = new File([res.data], fileName, {
        type: 'application/x-hwp'
      });

      await saveFile({ state: indexedDBState, dispatch: indexedDBDispatch, file });
      if (indexedDBState.status === 'unsupported') {
        const confirm = await confirmPromise({
          title: i18n.t('Common.Notification'),
          message: i18n.t('Common.OpenCurrentTabWarning'),
          btn: {
            confirm: {
              text: i18n.t('Common.Confirm')
            },
            cancel: {
              text: i18n.t('Common.Cancel')
            }
          }
        });
        if (confirm) {
          dispatch(hideFileMenu());
          openCurrentTab(file, (executeTime, fileBlob) => {
            ga.event({
              category: '문서열기',
              action: '기기문서',
              label: '시작화면',
              value: executeTime
            });
            ga.event({
              category: '사용지표',
              action: '열람 문서 크기',
              label: '기기문서',
              value: fileBlob.size
            });
          });
        }
      } else {
        dispatch(hideFileMenu());
        openNewTab(QS_CONSTANT.START_MODE.VALUES.OPEN_MOST_RECENT_DOC);
      }
    } catch (error) {
      dispatch(hideFileMenu());
      dispatch(showToast({ msg: t('NewDocumentsContents.TemplateFileOpeningFail') }));
    }
  };
  const onClickItem = (fileName) => {
    ga.event({ category: '파일탭', action: '템플릿' });
    openTemplateFile(fileName);
  };

  const onClickNew = () => {
    ga.event({ category: '파일탭', action: '새문서' });
    dispatch(hideFileMenu());
    openNewTab(QS_CONSTANT.START_MODE.VALUES.NEW_DOC);
  };

  const openNewTab = (startMode) => {
    openNewTabWithQueryinSameDomain(startMode);
  };

  return (
    <>
      <Container>
        <ContentsTitle>{t('NewDocumentsContents.ContentsTitle')}</ContentsTitle>
        <Grid>
          <GridItem onClick={onClickNew}>
            <GridThumnailBorder width={templates.width} height={templates.height}>
              <img src={newCrossImg} srcSet={newCrossImg2x} alt="" width="37px" height="37px"></img>
            </GridThumnailBorder>

            <GridItemTitle>{t('HwpTemplateItems.New')}</GridItemTitle>
          </GridItem>
          {templates &&
            templates.items.map((ele) => (
              <GridItem key={ele.fileName} onClick={() => onClickItem(ele.fileName)}>
                <GridThumnailBorder width={templates.width} height={templates.height}>
                  <GridThumnail
                    src={ele.thumnailImage}
                    srcSet={ele.thumnailImage2x}
                    alt=""
                    width={templates.width}
                    height={templates.height}
                  />
                </GridThumnailBorder>

                <GridItemTitle>{t(ele.titlei18nID)}</GridItemTitle>
              </GridItem>
            ))}
        </Grid>
      </Container>
    </>
  );
}

export default NewDocumentsContents;
